/**
 * Типы чата — зеркало ответов бэкенда (src/chat/chat.view.ts).
 * Канал: uuid машины (тред) или `general` (общий чат).
 */
import {IUserBrief} from "../../board/model/types";

export const GENERAL = "general";

export interface IChatAttachment {
    id: string;
    file_name: string;
    thumb_name: string | null;
    original_name: string;
    mime: string;
    size: number;
    width: number | null;
    height: number | null;
}

export interface IChatReaction {
    emoji: string;
    user_ids: string[];
}

export interface IChatMessage {
    id: string;
    car_id: string | null;
    kind: "user" | "system" | string;
    text: string;
    author: IUserBrief | null;
    created_at: string;
    edited_at: string | null;
    attachments: IChatAttachment[];
    reactions: IChatReaction[];
}

export interface IReactionsEvent {
    message_id: string;
    car_id: string | null;
    reactions: IChatReaction[];
}

export interface IDeletedEvent {
    id: string;
    car_id: string | null;
}

/** Тред машины в списке «Обсуждения» (GET /chat/threads, S11). */
export interface IThread {
    car_id: string;
    vin: string;
    color_id: string | null;
    stage: string;
    last: {author: IUserBrief | null; text: string; has_attachments: boolean; created_at: string};
    message_count: number;
    unread: number;
}

/** Ключ канала по сообщению. */
export const channelOf = (m: {car_id: string | null}): string => m.car_id ?? GENERAL;

/** Сообщений за один запрос. */
export const MESSAGES_PAGE = 50;

/** Лимит вложения (бэкенд — ATTACHMENT_MAX_BYTES). */
export const ATTACHMENT_MAX_BYTES = 50 * 1024 * 1024;
